<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  /*@import "style/reset.css";*/
  html,body{
    width: 100%;
    height: 100%;
  }
  @media screen  and (min-width: 960px) and (max-width: 2560px){
    #app {
      width: 100%;
      height: 100%;
      /* min-width: 1400px; */
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #2c3e50;
    }
  }
  @media screen and (max-width: 960px){
    #app {
      width: 100%;
      height: 100%;
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #2c3e50;
    }
  }
</style>



// WEBPACK FOOTER //
// src/civillan/App.vue